import Vue from 'vue';

export default Vue.component('readableidsfilter', {
    template:`
    <div class="form-group">
        <label :for="inputId">{{ label }}</label>
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ prefix }}</span>
            </div>
            <input @keyup="getFilterData" :id="inputId" :value="text" :readonly="readonly" type="text" class="form-control" maxlength="8">
        </div>
        <div class="font-size-sm mt-2">{{ description }}</div>
    </div>
    `,
    data: function(){
        return {
            inputGroupClass: 'input-group push-5-t',
            validationErrors: false,
            validationErrorsClass: 'has-error'
        };
    },
    props:{
        id: { 
            type: String, 
            default: null 
        },
        label: { 
            type: String, 
            default: ''
        },
        prefix: { 
            type: String, 
            required: true 
        },
        value: { 
            type: String, 
            default: '' 
        },
        text: { 
            type: String, 
            default: ''
        },
        description: { 
            type: String, 
            default: ''
        },
        readonly: { 
            type: Boolean, 
            default: false 
        },
        isFormField: {
            type: Boolean,
            default: true
        },
        data : Object
    },
    computed:{
        inputId() {
            return this.id !== null ? this.id : `readableid-${this._uid}`;
        }
    }
});